import { useRouteError } from "react-router-dom";
import { Link } from "@/lib/navigation";
import SeoHead from "@/components/SeoHead";

export default function RouteErrorBoundary() {
  const error = useRouteError();

  return (
    <>
      <SeoHead
        title="Error | NovelNet"
        description="Something went wrong on NovelNet."
        canonicalPath="/"
        noindex
      />
      <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>Something went wrong</h1>
      <p>{error?.statusText || error?.message || "Unexpected error"}</p>
      <Link to="/">Return home</Link>
    </div>
    </>
  );
}
